import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RecentActivitiesDataProps, RecentActivitySliceProp } from "../../type";
import { get } from "../../util/APIService";
import { HttpStatus } from "../../enums/httpStatus";

export const getRecentActivities = createAsyncThunk(
  "admin/activities/recent",
  async (params: RecentActivitySliceProp, storeActions) => {
    const url = `api/v1/admin/recent-activities?activity=${params.activity}` + params.requestingParams;
    const response: any = await get(url, storeActions);

    if (response.status === HttpStatus.OK) {
      return {
        status: HttpStatus.OK,
        data: await response.json(),
      };
    } else {
      return {
        status: response.status,
        text: await response.text(),
      };
    }
  }
);

const recentActivitiesSlice = createSlice({
  name: "recentActivities",
  initialState: {
    status: null as number | null,
    loading: false as boolean,
    text: null as string | null,
    data: [] as Array<RecentActivitiesDataProps> | null,
  },
  reducers: {
    clearData: (state) => {
      state.status = null;
      state.loading = false;
      state.text = null;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getRecentActivities.fulfilled, (state, action) => {
      state.status = action.payload.status;
      state.loading = false;
      if (action.payload.data !== undefined) {
        state.data = action.payload.data;
        state.text = null;
      } else if (action.payload.text !== undefined) {
        state.data = null;
        state.text = action.payload.text;
      }
    });
    builder.addCase(getRecentActivities.pending, (state) => {
      state.status = null;
      state.loading = true;
      state.data = null;
      state.text = null;
    });
    builder.addCase(getRecentActivities.rejected, (state) => {
      state.status = 503;
      state.loading = false;
      state.data = null;
      state.text = null;
    });
  },
});

export const { clearData } = recentActivitiesSlice.actions;

export default recentActivitiesSlice;
